var path = 'templates/transcription/content.html';
var html = "<md-nav-bar style=width:100% md-selected-nav-item=childState nav-bar-aria-label=navigation> <md-nav-item md-nav-sref=.view name=view>{{'transcription.view' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.input name=input>{{'transcription.input' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.notes name=notes>{{'transcription.notes' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.history name=history>{{'transcription.history' | translate}}</md-nav-item> <md-nav-item md-nav-sref=.legends name=legends>{{'transcription.guide' | translate}}</md-nav-item> </md-nav-bar> <div ui-view flex style=background:#fff> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/content.html
// module id = 59
// module chunks = 0